import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedFilterIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 18 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18 9.75C18 9.33579 17.6642 9 17.25 9H12.75C12.3358 9 12 9.33579 12 9.75C12 10.1642 12.3358 10.5 12.75 10.5H17.25C17.6642 10.5 18 10.1642 18 9.75Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 5.25C18 4.83579 17.6642 4.5 17.25 4.5H6.75C6.33579 4.5 6 4.83579 6 5.25C6 5.66421 6.33579 6 6.75 6H17.25C17.6642 6 18 5.66421 18 5.25Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 0.75C18 0.335786 17.6642 0 17.25 0H0.75C0.335787 0 0 0.335786 0 0.75C0 1.16421 0.335787 1.5 0.75 1.5H17.25C17.6642 1.5 18 1.16421 18 0.75Z",
			fill: "#4B7987"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedFilterIcon);
const Memo = memo(ForwardRef);
export default Memo;
